<template>
  <div>
    <titleBar :title="title"></titleBar>
    <div class="course_list">  
        <div v-if="courseInfo.length !== 0" class="course_items" v-for="(item, index) in courseInfo" :key="index">
            <img :src="item.imgUrl" alt="">
            <div>
                <p>{{item.title}}</p>
                <div v-if="item.groupTime == 0">
                    <div>
                        <span>发团时间：</span>
                        <span class="time">{{formatDayTime(item.openTime)}}</span>  
                    </div> 
                    <span class="status">拼团中</span>
                </div>
                <div v-else>
                    <div>
                        <span>成团时间：</span>
                        <span class="time">{{formatDayTime(item.groupTime)}}</span>  
                    </div> 
                    <span class="status">拼团完成</span>
                </div>
            </div>
        </div>
        <div v-if="courseInfo.length == 0" class="noClass">
          <img src="https://appd.knowbox.cn/ss/activity/group-buy/no-class.png" alt="">
          <p>暂无拼团课程～</p>
        </div>
    </div>   
  </div>

</template>

<script>
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/titleBar.vue";

export default {
  name: "course_list",
  components: {},
  data() {
    return {
      courseInfo: [],
      title: "拼团课程"
    };
  },
  components: {
    titleBar
  },
  created: function() {
    console.log("======================createdcreated===============");
    this.$api
      .myGroupBuying({
        token: utils.getQueryString("token")
      })
      .then(data => {
        this.courseInfo = data.list;
      })
      .catch(res => {
        this.$toast(res.msg);
      });
  },
  methods: {
    footerClick() {
      this.$emit("footerClick");
    },
    formatDayTime: function(time) {
      time = new Date(time * 1000);
      let year, month, day, hour, minute, second;
      function formate(time) {
        return time < 10 ? "0" + time : time;
      }
      year = formate(time.getFullYear());
      month = formate(time.getMonth() + 1);
      day = formate(time.getDate());
      hour = formate(time.getHours());
      minute = formate(time.getMinutes());
      second = formate(time.getSeconds());
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.course_list {
  width: 100%;
  margin-top: 1.18rem;
  .course_items {
    width: 100%;
    height: 1.89rem;
    background-color: #ffffff;
    margin-bottom: 0.2rem;
    display: flex;
    align-items: center;
    padding: 0 0.3rem;
    img {
      width: 2rem;
      height: 1.28rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      margin-right: 0.2rem;
    }
    > div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 4.69rem;
      height: 1.08rem;
      p {
        font-family: PingFangSC-Semibold;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #424243;
      }
      > div {
        display: flex;
        justify-content: space-between;
        span {
          font-family: PingFangSC-Regular;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #919294;
        }
        div {
          .time {
            font-size: 0.24rem;
            color: #bec0c2;
          }
        }
        .status {
          font-family: PingFangSC-Medium;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ff5c5c;
        }
      }
    }
  }
  .noClass {
    position: fixed;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    text-align: center;
    font-size: 0.36rem;
    color: #919294;
    img {
      width: 2.79rem;
      height: 2.61rem;
    }
  }
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .course_list {
    margin-top: 2.18rem;
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .course_list {
    margin-top: 2.18rem;
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .course_list {
    margin-top: 2.18rem;
  }
}
</style>